((app) => {
    let src = document.querySelectorAll("script");
    let srcInfo = null;

    for (let i = 0; i < src.length; i++) {
        if (src[i].src.indexOf("/build/app.min.js") >= 0)
            srcInfo = src[i].src;
    }

    if (srcInfo !== null) {
        let rel = srcInfo.substring(srcInfo.indexOf("rel=") + "rel=".length);

        app.config([
            "$templateRequestProvider", function ($templateRequestProvider) {
                $templateRequestProvider.httpOptions({
                    params: {
                        rel: rel
                    }
                });
            }
        ]);
    }
})(window.app);
